import { Observable } from "rxjs";




export abstract class IVisibilityStateService {

  abstract VisibilityState(): Observable<boolean>;

}

